import Slider from 'react-slick';
import React, { useEffect, useState, useRef } from 'react';
import { ImageDetail } from '../types';
import { useTranslation } from 'react-i18next';

interface ThumbnailSliderProps {
    images: ImageDetail[];
    activeIndex: number;
    setActiveIndex: (index: number) => void;
    onImageClick: (index: number) => void;
}

export const ThumbnailSlider: React.FC<ThumbnailSliderProps> = ({
    images,
    activeIndex,
    setActiveIndex,
    onImageClick
}) => {

    const { t } = useTranslation();

    const sliderRef = useRef<Slider>(null);

    useEffect(() => {
        if(!sliderRef.current) return;

        if(activeIndex == 0)return;

        if (sliderRef.current) {
            sliderRef.current.slickGoTo(activeIndex, true);
        }
    }, [activeIndex]);

    // Calcola dinamicamente slidesToShow in base alla larghezza dello schermo

    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
    const [slidesToShow, setSlidesToShow] = useState<number>(1);
    const [arrowVisibility, setArrowVisibility] = useState<boolean>(true);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (windowWidth < 768) {
            setSlidesToShow(1);
            setArrowVisibility(false);
        } else {
            setSlidesToShow(2);
            setArrowVisibility(true);
        }
    }, [windowWidth]);

 const baseSliderSettings = {
    dots: false,
    arrows: arrowVisibility,

    infinite: true,
    speed: 500,

    slidesToScroll: 1,
    slidesToShow: slidesToShow,

    focusOnSelect: false,
    swipeToSlide: false,

    autoplay: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,

    variableWidth: true,
    centerMode: false,
    centerPadding: "0px",
    adaptiveHeight: true
};

    if (!images || images.length === 0) {
        return null;
    }

    return (
        <div className='carosello-dettaglio'>
            <div className='row'>
                <div className='col-md-3 d-none d-md-block'>
                    <div className='slider slider-nav limit-height position-relative thumbnail-slider' style={{ height: '100%' }}>
                        <div className="first-block thubnail-title-box d-flex flex-column justify-content-end">
                            <h3>Gallery</h3>
                        </div>
                    </div>
                </div>
                <div className='col-12 col-md-9'>
                    <Slider 
                        ref={sliderRef}
                        {...baseSliderSettings}
                        afterChange={(current) => { if (current !== activeIndex) { setActiveIndex(current) } }}
                    >

                        {images.map((img, index) => (
                            <div key={index} className="slick-slide" style={{ outline: "none" }}>
                                <img
                                    className="img-fluid"
                                    alt={`Thumbnail ${index + 1}`}
                                    src={img.urlSmall ?? '/assets/images/no_image_small.jpg'}
                                    style={{
                                        cursor: "pointer",
                                        objectFit: "cover"
                                    }}
                                    onClick={() => {
                                        setActiveIndex(index), onImageClick(index);
                                    }}
                                    loading="lazy"
                                    onError={(e) => {
                                        e.currentTarget.src = '/assets/images/no_image_small.jpg';
                                        e.currentTarget.alt = t('gallery.thumbnailAltFallback', 'Miniatura non disponibile');
                                    }}
                                />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    );
};